module.exports = __webpack_public_path__ + "static/media/slide-1-full-rtl.343b48ea.jpg";